import logo from './logo.svg';
import './App.css';
// import LandingPage from './marketing-page/LandingPage';
import ChatToggle from './components/ChatWindow/ChatToggle';
function App() {
  return (
    <div className="App">
     <iframe
       src="https://www.mdc.edu"
       title="MDC demo screen"
       style={{
         position: "fixed",
         top: 0,
         left: 0,
         width: "100vw",
         height: "100vh",
         border: "none",
         margin: 0,
         padding: 0,
         zIndex: 1,
         background: "white"
       }}
     />
     <ChatToggle />
    </div>
  );
}

export default App;
